import storage from 'localforage'

storage.config({
  name: 'chronicle',
  driver: storage.INDEXEDDB
})

const subscriber = (mutation, {milestones, log, loaded}) => {
  if (loaded) {
    if (mutation.type.toLowerCase().includes('milestone')) {
      storage.setItem('milestones', milestones)
    }
    if (mutation.type.toLowerCase().includes('log')) {
      storage.setItem('log', log)
    }
  }
}

export const persistence = store => {
  store.commit('loaded', false)

  const milestones = storage.getItem('milestones')
    .then(milestones => {
      if (milestones) {
        milestones.forEach(item => store.commit('addMilestone', item))
      }
    })
    .catch(error => store.commit('log', error + ' from adapter'))

  const log = storage.getItem('log')
    .then(entries => {
      if (entries) {
        store.commit('prependLogEntries', entries)
      }
    })
    .catch(error => store.commit('log', error + ' from adapter'))

  Promise.all([milestones, log]).then(() => {
    store.commit('log', 'Loaded milestones and logs from storage.')
    store.commit('loaded', true)
  })

  store.subscribe(subscriber)
}
